import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './redux/actions';

const camposProdutos = [
  {
    id: Math.random(),
    nomeCampo: 'qtdeVideos',
    descricaoCampo: 'Qtde de Videos',
    tipo: 'number',
  },
  {
    id: Math.random(),
    nomeCampo: 'nome',
    descricaoCampo: 'Produto',
    tipo: 'string',
  },
  {
    id: Math.random(),
    nomeCampo: 'dtCriacao',
    descricaoCampo: 'Data Cadastro',
    tipo: 'date',
  },
  {
    id: Math.random(),
    nomeCampo: 'negociacaoPontual',
    descricaoCampo: 'Neg. Pontual',
    tipo: 'bool',
  },
  {
    id: Math.random(),
    nomeCampo: 'dtAlteracao',
    descricaoCampo: 'Data Alteração',
    tipo: 'rangeDate',
  },
];

const filterBase = { filter: {} };
const filterInicial = {
  filter: {
    where: [
      {
        campo: 'qtdeVideos',
        operador: '=',
        valor: 2,
        tipoCampo: 'string',
      },
    ],
  },
};
export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
 constructor(props) {
    super(props);

    this.pesquisarProdutos = this.pesquisarProdutos.bind(this);
  }

  pesquisarProdutos = async (params) => {
    console.log ( params );
  };
  componentWillMount = () => {
    this.props.history.push(`/login-sap/impersonate`);
  }
  render() {
    const data = { titulo: 'Filtro de Produtos Seca Você', campos: camposProdutos };

    return (
      <div className="home-default-page">
        <header className="">
          {/* <img src={reactLogo} className="app-logo" alt="logo" />
          <img src={rekitLogo} className="rekit-logo" alt="logo" /> */}
          <h1 className="app-title">Welcome to EriMasterData</h1>
        </header>
        {/* <div className="app-intro">
          <h3>To get started:</h3>
          <ul>
            <li>
              Edit component{' '}
              <a
                href="http://localhost:6076/element/src%2Ffeatures%2Fhome%2FDefaultPage.js/code"
                target="_blank"
                rel="noopener noreferrer"
              >
                src/features/home/DefaultPage.js
              </a>{' '}
              for this page.
            </li>
            <li>
              Edit component{' '}
              <a
                href="http://localhost:6076/element/src%2Ffeatures%2Fhome%2FApp.js/code"
                target="_blank"
                rel="noopener noreferrer"
              >
                src/features/home/App.js
              </a>{' '}
              for the root container layout.
            </li>
            <li>
              To see examples, access:&nbsp;
              <Link to="/examples">/examples</Link>
            </li>
            <li>
              Rekit Studio is running at:&nbsp;
              <a href="http://localhost:6076/" target="_blank" rel="noopener noreferrer">
                http://localhost:6076/
              </a>.
            </li>
          </ul>
        </div> */}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js